import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import './FilterLabel.scss';
import { textUtils } from '@instinet-analytics/core-lib';

const { pluralise } = textUtils;

export interface FilterLabelProps {
    filterApplied: boolean;
    filteredRowCount: number;
}

/**
 * FilterLabel
 * Renders a label with a filter status
 */
export default function FilterLabel(props: FilterLabelProps) {
    const { numberFormat } = useContext(AppContext);

    let label = ` - ${numberFormat.n0(props.filteredRowCount)} ${pluralise(
        props.filteredRowCount,
        'result'
    )}`;
    if (props.filterApplied) {
        label += `, filter applied`;
    }

    return <div className="FilterLabel">{label}</div>;
}
